export enum NotificationStatus {
  CONFIRM_CRASH = 'CONFIRM_CRASH',
  NOTI_SENT = 'NOTI_SENT',
  NO_NEED_HELP = 'NO_NEED_HELP',
  NO_ACTION = 'NO_ACTION',
}

export enum ContactStatus {
  NOT_CONTACTED = 'notContacted',
  UNREACHABLE = 'unReachable',
  CALLBACK_REACHED = 'contacted',
  NO_NEED_TO_CONTACT = 'notApplicable',
}

export enum IncidentStatus {
  UNKNOWN = 'noStatus',
  CRASHED = 'crash',
  NO_CRASH = 'noCrash',
}

export enum SurveyorStatus {
  SENT = 'true',
  NOT_SENT = 'false',
}

export const NOTIFICATION_STATUS_OPTIONS = [
  {
    value: NotificationStatus.CONFIRM_CRASH,
    label: 'กดยืนยันการชน',
    color: '#EF2605',
    hasPhoneIcon: true,
  },
  {
    value: NotificationStatus.NOTI_SENT,
    label: 'ส่ง noti แจ้งการชน',
    color: '#FFA100',
    hasPhoneIcon: false,
  },
  {
    value: NotificationStatus.NO_NEED_HELP,
    label: 'กดไม่ต้องการความช่วยเหลือ',
    color: '#C2C2C2',
    hasPhoneIcon: false,
  },
  {
    value: NotificationStatus.NO_ACTION,
    label: 'ไม่มีการกด',
    color: '#C2C2C2',
    hasPhoneIcon: false,
  },
]

export const CONTACT_STATUS_OPTIONS = [
  {
    value: ContactStatus.NOT_CONTACTED,
    label: 'ยังไม่ได้ติดต่อ',
    color: '#FFA100',
  },
  {
    value: ContactStatus.UNREACHABLE,
    label: 'ติดต่อไม่ได้',
    color: '#EF2605',
  },
  {
    value: ContactStatus.CALLBACK_REACHED,
    label: 'โทรหาแล้วติดต่อได้',
    color: '#009640',
  },
  {
    value: ContactStatus.NO_NEED_TO_CONTACT,
    label: 'ไม่เข้าเงื่อนไขการติดต่อ',
    color: '#C2C2C2',
  },
]

export const INCIDENT_STATUS_OPTIONS = [
  {
    value: IncidentStatus.UNKNOWN,
    label: 'ยังไม่ทราบสถานะ',
    color: '#C2C2C2',
  },
  {
    value: IncidentStatus.CRASHED,
    label: 'มีการชน',
    color: '#EF2605',
  },
  {
    value: IncidentStatus.NO_CRASH,
    label: 'ไม่มีการชน',
    color: '#009640',
  },
]

export const SURVEYOR_STATUS_OPTIONS = [
  {
    value: SurveyorStatus.SENT,
    label: 'ส่ง',
    color: '#009640',
  },
  {
    value: SurveyorStatus.NOT_SENT,
    label: 'ไม่ส่ง',
    color: '#C2C2C2',
  },
]
